import React from 'react';
import { InstantSearch, Configure } from 'react-instantsearch-dom';
import { withRouter } from 'react-router-dom';

import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import GridWithSidebar from 'components/consumer/GridWithSidebar';
import { PhotoCardsResultSearch } from 'components/consumer/inspiration-photos-grid/search-state/utils';
import { withSearchState } from 'components/consumer/inspiration-photos-grid/search-state/withSearchState';

const SearchCustomerPhotosContent = ({
  facetFilters,
  filterActions,
  getCustomProps,
  hoveredValue,
  indexName,
  searchState,
  searchStateQuery,
  toggleReviewOnHover,
  updateSearchPage,
}) => (
  <div className="w-full">
    <InstantSearch
      searchClient={searchClient}
      searchState={searchState}
      indexName={indexName}
    >
      <Configure
        query={searchStateQuery}
        hitsPerPage={9}
        facetFilters={facetFilters}
        facets={['*']}
        numericFilters=""
      />

      <div className="[&_.infinite-scroll-component]:flex [&_.infinite-scroll-component]:flex-row [&_.infinite-scroll-component]:items-start [&_.infinite-scroll-component]:flex-wrap [&_.infinite-scroll-component]:justify-between [&_.infinite-scroll-component]:min-w-full">
        <GridWithSidebar
          getCustomProps={getCustomProps}
          gridItemType="customer-photo"
          mobileItemsPerRow={1}
          naturalHeightImages
          renderGrid={({
            selectedGridItem,
            updateSelectedGridItem,
            showOnTop = false,
          }) => (
            <PhotoCardsResultSearch
              filterActions={filterActions}
              hoveredValue={hoveredValue}
              onHoverHandler={toggleReviewOnHover}
              searchMore={updateSearchPage}
              selectedGridItem={selectedGridItem}
              showModalOnClick
              showOnTop={showOnTop}
              updateSelectedGridItem={updateSelectedGridItem}
            />
          )}
          tabsConfig={{
            products: true,
            productsTitle: ' ',
            productsHideLoadMore: true,
          }}
          variant="InspirationPage"
        />
      </div>
    </InstantSearch>
  </div>
);

export default withRouter(withSearchState(SearchCustomerPhotosContent));
